import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 overflow-hidden min-h-[100svh] md:min-h-0 flex flex-col justify-center py-4 md:pt-16 md:pb-16" data-id="element-284" data-mp="mz5vbfm4mugs">
      <div className="max-w-[700px] w-full mx-auto text-center flex flex-col gap-[clamp(10px,2vh,24px)] md:gap-6" data-id="element-285" data-mp="wrle2f58zn2q">
        <FadeIn data-id="element-286" data-mp="3va92pjj553ii">
          <div className="flex flex-col gap-[clamp(6px,1.2vh,16px)] md:gap-4" data-id="element-287" data-mp="3vas9q57967hr">
            <div className="inline-flex self-center items-center gap-1.5 bg-bg-card text-brandViolet font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandViolet/40" data-id="element-288" data-mp="43frdmumvo09">
              <span className="text-sm md:text-base leading-none" data-id="element-289" data-mp="1kgwhk4dzfvkk">🔮</span>
              <span className="text-[8.5px] leading-none" data-id="element-290" data-mp="1kgmscj0rhsfx">
                BIBLIOTECA MAESTRA DEL CÓDIGO DE LOS CHAKRAS™
              </span>
            </div>
            <h1 className="font-hero font-bold uppercase text-[min(6.3vw,25px)] md:text-[54px] leading-[1.15] md:leading-[1.1] tracking-[0.3px] md:tracking-[0.5px] text-txt-primary px-1" data-id="element-291" data-mp="1hakdhj263in8">
             TODO LO QUE NECESITAS PARA{' '}
              <span className="text-brandViolet" data-id="element-292" data-mp="187sy586682qb">PROFUNDIZAR TU PRÁCTICA</span>
              <br data-id="element-293" data-mp="139rf2n8qw3eu" />
              <span data-id="element-294" data-mp="13a9lgcp4fy0h">ORGANIZADO. DESDE HOY.</span>
            </h1>

            <p className="text-txt-body text-[min(3.1vw,13px)] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-2" data-id="element-295" data-mp="ybq0ofm9ks9p">
              6 Módulos · Afirmaciones · Meditaciones · Rituales · Todo
              imprimible
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-296" data-mp="kkbddwlbq4wu">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-297" data-mp="kl2z8fp4co9x">
            <div className="absolute inset-0 bg-brandViolet/20 blur-[40px] rounded-full" data-id="element-298" data-mp="fkp05n5hwoo1"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandIndigo-electric/20 blur-[28px] rounded-full" data-id="element-299" data-mp="am5dfkj2v8um"></div>
            <img src="https://cdn.magicpatterns.com/uploads/aiAoxphTtZMJYC7JTizVDH/Mockup_stiker.png" alt="Biblioteca Maestra del Código de los Chakras — Mockup completo del producto" loading="eager" decoding="async"
          // @ts-ignore — supported by modern browsers
          fetchpriority="high" className="relative block w-auto max-w-[min(260px,72vw)] max-h-[32svh] md:max-w-[540px] md:max-h-none mx-auto object-contain [@media(hover:hover)]:hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-300" data-mp="y027pqw6jjr" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-301" data-mp="opwzmbtlh91c">
          <div className="max-w-2xl mx-auto flex flex-col gap-[clamp(8px,1.6vh,20px)] md:gap-5" data-id="element-302" data-mp="9z7r5h7iq816">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-303" data-mp="ewg9bhso2c2f">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-304" data-mp="12mttyn8x98mz">
                <span className="text-[10px] md:text-xs" data-id="element-305" data-mp="2s365jrdqgact">📄</span> 100% PDF ·
                Imprimible
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-306" data-mp="2n3jo15qvg7y7">
                <span className="text-[10px] md:text-xs" data-id="element-307" data-mp="2wxtjwxf0vodo">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-308" data-mp="2471pa4dlv7sg">
                <span className="text-[10px] md:text-xs" data-id="element-309" data-mp="2e57twtqsqs10">📚</span> 475 páginas
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="flex flex-col gap-[clamp(6px,1.2vh,14px)] md:gap-3" data-id="element-310" data-mp="3tjwvssjeq9jj">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[min(3.8vw,15px)] md:!text-base" data-id="element-311" data-mp="3pjd0luie9g01">
                💜 QUIERO LA BIBLIOTECA AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-312" data-mp="sra6xy91v0gp">
                <span className="flex items-center gap-1" data-id="element-313" data-mp="12oook16plval">
                  <ShieldCheck size={11} className="text-success" data-id="element-314" data-mp="12q9fzhxq8y48" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-315" data-mp="17lyl00sin77x">
                  <Lock size={11} className="text-txt-muted" data-id="element-316" data-mp="1bo1ysw2nqnwd" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-317" data-mp="1gh4lqlcxiz3l">
                  <CreditCard size={11} className="text-brandViolet" data-id="element-318" data-mp="1lewlg1jtfpic" /> Pagas en
                  tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+300',
    label: 'terapeutas dominan con esto'
  }, {
    value: '6',
    label: 'Módulos listos'
  }, {
    value: '5',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-319" data-mp="35wfaknrd3pvv">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-320" data-mp="35z1nl2x0uxlh">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-321" data-mp="30zfbwxwudpes">
          {stats.map((stat, i) => <FadeIn key={stat.label} delay={0.1 + i * 0.1} data-id="element-322" data-mp="2fq8bdytb2c0" data-mpi={i}>
              <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandViolet mb-0.5" data-id="element-323" data-mp="3tmjdeswq7llt">
                {stat.value}
              </div>
              <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-324" data-mp="3jwzu5m53ppqf">
                {stat.label}
                {stat.star && <Star size={12} className="fill-gold text-gold" data-id="element-325" data-mp="l7rhb95aw8z5" />}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Antes juntaba apuntes dispersos de 10 cursos. Aquí encontré TODO organizado. Me ayudo realmente para lo que hago.',
    author: 'Marcela R.',
    role: 'Terapeuta Holística · México',
    bg: 'bg-brandViolet'
  }, {
    initials: 'CP',
    text: 'Tenía dudas antes de comprarlo, pero me sorprendió. Cada módulo conecta con el siguiente perfectamente.',
    author: 'Carolina P.',
    role: 'Practicante de Reiki · Colombia',
    bg: 'bg-brandIndigo-electric'
  }, {
    initials: 'DG',
    text: 'Imprimí los módulos. Los tengo en mi escritorio. En cada sesión sé exactamente qué hacer.',
    author: 'Diego G.',
    role: 'Facilitador de Bienestar · Perú',
    bg: 'bg-brandViolet'
  }];
  return <Section className="bg-bg-base" data-id="element-326" data-mp="1n0n2xhabjs17">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-327" data-mp="3ccyzbawpp9ot">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-328" data-mp="3hctnh6p3rl66" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-329" data-mp="3ha7h3ady7bpj">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-330" data-mp="10qnap5i784l6">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-331" data-mp="10o0u6gdbyeqt">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-332" data-mp="1offyufskx858">
                  <div className="flex text-gold mb-0.5" data-id="element-333" data-mp="1oe4uoev81ydl">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-334" data-mp="1jflaok06uwnv" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-335" data-mp="1ycufafei5wxj">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-336" data-mp="3zl0c836tj7w">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-337" data-mp="3v8ieskhrrtpd">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandViolet mt-auto pt-2.5" data-id="element-338" data-mp="3eb1inh5shw6x">
                Compró la Biblioteca
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Aprendiste sobre chakras en un lugar, sobre cristales en otro y sobre meditación en otro más y a la hora de aplicarlo, no sabes por donde empezar', 'No tienes un SISTEMA completo donde TODO conecte y esté en un solo lugar', 'Repites los mismos recursos porque no tienes tiempo para preparar sesiones adaptadas a cada necesidad.', 'Un consultante nuevo llega y buscas por internet o tus apuntes antes de actuar', 'Conoces mucho pero no lo dominas realmente porque está disperso en 10 lugares', 'Quieres profundizar pero necesitas TODO organizado para hacerlo con seguridad', 'Cada fin de semana vuelves a buscar información en distintos lugares y el ciclo se repite'];
  return <Section className="bg-bg-alt" data-id="element-339" data-mp="203lmhie8av0z">
      <div className="max-w-[720px] mx-auto" data-id="element-340" data-mp="205exf9vvk1es">
        <FadeIn data-id="element-341" data-mp="1vdezfmzd7iku">
          <h2 className="font-display font-extrabold uppercase md:text-[36px] text-center mb-8 text-txt-primary text-[22px] leading-[1.25]" data-id="element-342" data-mp="1vcvf5zm8si3n">
            Si eres <span className="text-brandViolet" data-id="element-343" data-mp="1qe24eeycb576">terapeuta holístico,</span>
            <br data-id="element-344" data-mp="1lg0kxsx053v6" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-345" data-mp="1gfmjwuttiu6n">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-346" data-mp="1ce9iqy1o7f62" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-347" data-mp="17grdbhmv3i2t" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-348" data-mp="36stx6szeeeh0">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Neon divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12" style={{
          background: 'linear-gradient(90deg, transparent 0%, #8B5CF6 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(139,92,246,0.8), 0 0 24px rgba(139,92,246,0.5)'
        }} data-id="element-349" data-mp="ialnms2z9jot"></div>

          <h3 className="font-display font-extrabold uppercase md:text-[40px] text-center text-txt-primary mb-8 relative text-[24px] leading-[1.2]" data-id="element-350" data-mp="md04j6n369dg">
            ¿Sigues llegando a cada sesión{' '}
            <span className="text-brandViolet inline-block" style={{
            textShadow: '0 0 20px rgba(139,92,246,0.6), 0 0 40px rgba(139,92,246,0.4)'
          }} data-id="element-351" data-mp="3qs9ejrayf4vp">
              sin una planificación clara?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-352" data-mp="3knt7uegfxr6">
            <p data-id="element-353" data-mp="3c07gmcsg2lyb">
              Elegiste este camino porque amas el trabajo energético y
              transformar vidas.
            </p>
            <p data-id="element-354" data-mp="1ml6jq3imaced">
              Pero nadie te dijo que ibas a perder tiempo buscando herramientas
              que no conectan entre sí, estructurando sesiones a último momento
              y sintiendo que te falta algo para llegar al siguiente nivel.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandViolet rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(139,92,246,0.25)]" data-id="element-355" data-mp="1ikcv17xcotkf">
            <p className="font-display font-extrabold text-[18px] md:text-[26px] leading-[1.3] text-center text-txt-primary" data-id="element-356" data-mp="2abj082rxhhgk">
             ¿Y SI ESTA FUERA LA{' '}
              <span className="text-brandViolet" data-id="element-357" data-mp="1wdc9r7pb6jqx">ÚLTIMA SESIÓN</span>
              <br data-id="element-358" data-mp="2191b9gkw2apv" />
               QUE PREPARAS ASÍ?
            </p>
          </div>

          {/* Neon divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14" style={{
          background: 'linear-gradient(90deg, transparent 0%, #8B5CF6 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(139,92,246,0.8), 0 0 24px rgba(139,92,246,0.5)'
        }} data-id="element-359" data-mp="kyfidr5njige"></div>
        </FadeIn>
      </div>
    </Section>;
};